/* esm.sh - zod@4.6.5/v4/locales */
export * from "/*zod@4.6.5/esnext/v4/locales.mjs";
